import { ButtonProps, ButtonRenderProps } from "sprint-common-web";

import { ClearSelectedOnPremOrdersButton } from "./buttons/ClearSelectedOnPremOrdersButton";
import { PinOnPremOrderButton } from "./buttons/PinOnPremOrderButton";
import {
    SetOnPremOrderListingColumnsConfigButton,
    SetOnPremOrderListingColumnsConfigButtonProps
} from "./config/SetOnPremOrderListingColumnsConfigButton";
import { ExportOnPremOrdersButton, ExportOnPremOrdersButtonProps } from "./export/ExportOnPremOrdersButton";
import {
    ExportOnPremOrdersForProcessingButton,
    ExportOnPremOrdersForProcessingButtonProps
} from "./export/ExportOnPremOrdersForProcessingButton";
import { OnPremOrderListingFilters } from "./hooks/useOnPremOrderListingFilters";
import { UpdateMultipleOnPremOrdersStatusButton } from "./update-status/update-multiple/UpdateMultipleOnPremOrdersStatusButton";

type OnPremOrderListingButtons =
    | ButtonRenderProps<ButtonProps>
    | ButtonRenderProps<ExportOnPremOrdersButtonProps>
    | ButtonRenderProps<SetOnPremOrderListingColumnsConfigButtonProps>;

interface CreateOnPremOrderListingButtonsProps {
    filters: OnPremOrderListingFilters;
    setPageSize(pageSize: number): void;
}

export const createOnPremOrderListingButtons = (
    props: CreateOnPremOrderListingButtonsProps
): OnPremOrderListingButtons[] => {
    const { filters, setPageSize } = props;

    const exportOnPremOrdersProcessingButton: ButtonRenderProps<ExportOnPremOrdersForProcessingButtonProps> = {
        render: ExportOnPremOrdersForProcessingButton,
        filters
    };

    const updateMultipleOnPremOrdersStatusButton: ButtonRenderProps<ButtonProps> = {
        render: UpdateMultipleOnPremOrdersStatusButton
    };

    const exportOnPremOrdersButton: ButtonRenderProps<ExportOnPremOrdersButtonProps> = {
        render: ExportOnPremOrdersButton,
        filters
    };

    const setOrderListingColumnsConfigButton: ButtonRenderProps<SetOnPremOrderListingColumnsConfigButtonProps> = {
        render: SetOnPremOrderListingColumnsConfigButton,
        pageSize: filters.pageSize,
        setPageSize
    };

    const clearSelectedOnPremOrdersButton: ButtonRenderProps<ButtonProps> = {
        render: ClearSelectedOnPremOrdersButton
    };

    const pinOnPremOrdersButton: ButtonRenderProps<ButtonProps> = {
        render: PinOnPremOrderButton
    };

    return [
        updateMultipleOnPremOrdersStatusButton,
        exportOnPremOrdersButton,
        exportOnPremOrdersProcessingButton,
        pinOnPremOrdersButton,
        setOrderListingColumnsConfigButton,
        clearSelectedOnPremOrdersButton
    ];
};
